import { GetFlightPlacesState } from './getFlightPlaces.types'

const initialState: GetFlightPlacesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
